import cn from 'classnames';
import { FC, HTMLProps, PropsWithChildren } from 'react';
import { IoMdClose } from 'react-icons/io';
import { Link } from 'react-router-dom';
import { IconButton } from '../../components/icon-button/icon-button';
import { useLang } from '../../hooks/use-lang';
import { VariantType } from '../../types/props';
import s from './alert.module.css';

export type AlertType = {
  id?: string;
  label: string;
  variant?: VariantType;
  endless?: boolean;
  link?: string;
} & PropsWithChildren;

export interface AlertProps extends HTMLProps<HTMLDivElement> {
  className?: string;
  alert: AlertType;
  onClose?: () => void;
}

export const Alert: FC<AlertProps> = (props) => {
  const { alert, className, onClose, ...other } = props;
  const { label, variant = 'info', children } = alert;
  const { t } = useLang();

  const element = (
    <div className={cn(s.component, s[variant], className)} {...other} data-testid={other.id}>
      <label className={s.label}>
        {t(label)}
        <IconButton
          variant="ghost"
          outline={false}
          onClick={(e) => {
            e.preventDefault();
            onClose && onClose();
          }}
        >
          <IoMdClose />
        </IconButton>
      </label>
      {children}
    </div>
  );

  if (alert.link) {
    return (
      <Link to={alert.link} className={s.link}>
        {element}
      </Link>
    );
  }

  return element;
};
